import './header.scss'
import Headroom from 'headroom.js';

function init() {
  const offset = 120;
  const options = {
    // vertical offset in px before element is first unpinned
    offset
  }
  const header = document.getElementById('header');
  const headroom = new Headroom(header, options);
  headroom.init();

  // Burger menu
  const burger = document.querySelector('[data-burger]');
  burger.addEventListener('click', () => {
    burger.classList.toggle('is-active');
    document.body.classList.toggle('is-menu-open');
  });
}

export default init
